module.exports = __webpack_public_path__ + "static/img/investor_icon.b43cc001.svg";